import React, { Component } from "react";
// import { IoDocumentsSharp } from "react-icons/io5";
// import { GrDocumentExcel } from "react-icons/gr";
import axios from "axios";
// import { MdOutlineFileDownload } from "react-icons/md";
import { MdOutlineDeleteOutline } from "react-icons/md";
import {Link} from "react-router-dom"
 

class TutorExamSection extends Component {
    state = {
        exam: [],
    }
    handleExamDisplay = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover.addexam")
        formcontainer.style.display = "flex"
    }

    componentDidMount() {
        this.fetchCourses();
    }
    componentDidUpdate(prevProps) {
        if (this.props.shouldRefresh && this.props.shouldRefresh !== prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone(); // Important: Call the callback to reset the flag
        }
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get(`https://api.geoinfoacademy.com/api/tutor/exams/by-course/${courseId}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ exam: response.data });
            console.log("API Response for list of exam:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // handleDownload = async (doc) => {
    //     const accessToken = localStorage.getItem("accessToken");
    //     const documentId = doc.id; // Assuming your document object has an 'id' property

    //     try {
    //         const response = await axios.get(`https://api.geoinfoacademy.com/api/download/document/${documentId}/`, {
    //             headers: {
    //                 Authorization: `Bearer ${accessToken}`,
    //             },
    //             responseType: 'blob', // Important: Specify response type as blob
    //         });

    //         // Create a blob URL for the downloaded file
    //         const blob = new Blob([response.data], { type: response.headers['content-type'] }); // Get the content type from the response
    //         const url = window.URL.createObjectURL(blob);

    //         // Create a temporary link and trigger the download
    //         const link = document.createElement('a');
    //         link.href = url;

    //         // Extract filename from Content-Disposition header if available, else use the title.
    //         let filename = doc.title; // Default filename (if all else fails)

    //         const contentDisposition = response.headers['content-disposition'];

    //         if (contentDisposition) {
    //             // 1. Try to get filename from Content-Disposition header (BEST option)
    //             const filenameMatch = contentDisposition.match(/filename="(.+)"/);
    //             if (filenameMatch) {
    //                 filename = filenameMatch[1]; // Use filename from header
    //             }
    //         } else if (doc.file_path) {
    //             // 2. If Content-Disposition is missing, try to guess from doc.file_path (LESS reliable)
    //             try {  // Add a try-catch in case doc.file_path is malformed
    //                 const url = new URL(doc.file_path); // Use URL object for robust parsing
    //                 const pathname = url.pathname;
    //                 const ext = pathname.substring(pathname.lastIndexOf('.') + 1); // Extract extension

    //                 if (ext) {
    //                     filename = `${doc.title}.${ext}`; // Add guessed extension to title
    //                 } else {
    //                     console.warn("Could not determine extension from doc.file_path:", doc.file_path);
    //                 }

    //             } catch (error) {
    //                 console.error("Error parsing doc.file_path:", doc.file_path, error);
    //             }
    //         } else {
    //             console.warn("Neither Content-Disposition nor doc.file_path available for filename.");
    //         }


    //         link.setAttribute('download', filename); // Set the filename
    //         document.body.appendChild(link);
    //         link.click();
    //         link.remove();
    //         window.URL.revokeObjectURL(url);

    //     } catch (error) {
    //         console.error("Error downloading file:", error);
    //     }
    // };
    handleDelete = async (e, docId) => {
    // 1. Prevent the Link from navigating
    e.preventDefault(); 
    // 2. Stop the click from reaching the Link container
    e.stopPropagation(); 

    const accessToken = localStorage.getItem("accessToken");
    try {
        // 3. Use docId directly (not docId.id)
        const response = await axios.delete(`https://api.geoinfoacademy.com/api/tutor/exams/${docId}/`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        
        if (response.status === 204 || response.status === 200) { 
            console.log("Document deleted successfully:", docId);
            this.fetchCourses(); 
        } else {
            alert("Error deleting document");
        }
    } catch (error) {
        console.error("Error deleting document:", error);
        alert("Error deleting document");
    }
};

    render() {
        const document = this.state.exam;
        const examlist = 
        // document && document.documents && 
        document.length > 0 ? 
            document.map((exam) => {
                return (
                    <Link to={"/tutor_exam_question/" + exam.id}>
                    <li className="document" key={exam.id}>
                        {/* <IoDocumentsSharp />  */}
                        <span>{exam.title}</span> 
                        {/* <button onClick={() => this.handleDownload(exam.id)} className="download"><MdOutlineFileDownload /></button> */}
                        <button onClick={(e) => this.handleDelete(e , exam.id)} className="download"><MdOutlineDeleteOutline /></button>
                    </li>
                    </Link>
                );
            }) 
        : (
            <li className="document">
                {/* <GrDocumentExcel />  */}
                Awaiting exam upload
            </li>
        );
        return (
            <section className="exam_container">
                <h4>Exam<button onClick={this.handleExamDisplay}>Create Exam</button></h4>
                <div className="exam_cover">
                    {examlist}
                </div>
            </section>
        )
    }
}

export default TutorExamSection